// extracted by mini-css-extract-plugin
export default {"agreement":"Agreement_agreement_d_qMk"};